import type { FC } from 'react';
import React, { Fragment } from 'react';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';

import type { ExperienceAttributes } from '@confluence/experience-tracker/entry-points/ExperienceEvent';
import {
	ExperienceStart,
	ExperienceStop,
} from '@confluence/experience-tracker/entry-points/component';

import { LoadingState } from './homeViewsQueryHelpers';

type ExperienceTrackingType = {
	experienceName: string;
	loading: LoadingState;
	error?: ApolloErrorInterop;
	attributes?: ExperienceAttributes;
};

export const ExperienceTracking: FC<ExperienceTrackingType> = ({
	experienceName,
	loading,
	error,
	attributes,
}) => {
	return (
		<Fragment>
			<ExperienceStart name={experienceName} />
			{loading === LoadingState.done && (
				<ExperienceStop name={experienceName} error={error} attributes={attributes} />
			)}
		</Fragment>
	);
};
